<template>
  <VIcon 
    class="w-icon"
    v-bind="$props"
    v-on="$listeners"
  >
    <slot />
  </VIcon>
</template>

<script>
import { VIcon } from 'vuetify/lib';

/**
 * @component WorkIcon
 * @description Wrapper around Vuetify `VIcon` with Work-specific defaults.
 * Supports all Vuetify icon props as well as `disabled`.
 *
 * @prop {Boolean} [disabled=false] - Disable icon (grayed out).
 * @prop {String} [color='primary'] - Icon color.
 * @prop {Number|String} [size='1.25rem'] - Icon size.
 *
 * @slot default - Icon name (e.g. `$wEdit` or `mdi-plus`).
 */
export default {
  name: 'WorkIcon',
  components: { VIcon },
  props: {
    ...VIcon.options.props,
    disabled: { type: Boolean, default: false },
    color: { type: String, default: 'primary' },
    size: { type: [Number, String], default: '1.25rem' }
  },
};
</script>
